// src/functions/handleDeleteItem.js

import { doc, deleteDoc, getDoc } from "firebase/firestore";

/**
 * Handles the deletion of a cart item.
 *
 * @param {Object} firestore - The Firestore instance.
 * @param {String} cartID - The cart ID.
 * @param {String} cartItemId - The cart item ID.
 * @param {Number} itemQuantity - The quantity of the item to be deleted.
 * @param {Function} updateCartItems - Function to update cart items in state.
 */
const handleDeleteItem = async (firestore, cartID, cartItemId, itemQuantity, updateCartItems, collectionPath) => {
  try {
    const itemRef = doc(firestore, `${collectionPath}Carts/CartsList/DataBase/${cartID}/Items/${cartItemId}`);
    const itemDoc = await getDoc(itemRef);

    if (!itemDoc.exists()) {
      console.error("Item does not exist!");
      return;
    }

    await deleteDoc(itemRef);
    updateCartItems((prevItems) => prevItems.filter((item) => item.id !== cartItemId));
  } catch (error) {
    console.error("Error in handleDeleteItem:", error);
  }
};

export default handleDeleteItem;
